export default __webpack_public_path__ + "static/media/bmw-logo-new.dbdc79d9.png";